<template>
  <div
    class="d-flex flex-column"
    :class="
      !isFullScreen && isVerticalBar
        ? 'justify-end mb-10 align-center'
        : isFullScreen && !isVerticalBar
        ? 'align-start'
        : 'justify-start align-center'
    "
    :style="enqueteStyle"
    :key="item.id"
  >
    <header
      v-if="!hideTitle"
      class="d-flex align-center"
      :class="isFullScreen ? 'mb-8' : 'mb-4'"
    >
      <span :class="isFullScreen ? 'text-h3' : 'text-h6'" style="color: whitesmoke">
        {{ item.dsc_titulo_enquete }}
      </span>
    </header>
    <section
      :class="
        isVerticalBar && !isFullScreen
          ? 'd-flex align-end'
          : isVerticalBar && isFullScreen
          ? 'd-flex align-end'
          : !isVerticalBar && !isFullScreen
          ? 'horizontal-grid'
          : !isVerticalBar && isFullScreen
          ? 'horizontal-grid-fullscreen ml-6'
          : ''
      "
    >
      <div
        v-for="opcao in item.enquete_opcoes"
        :key="opcao.id"
        class="mx-1 d-flex align-center"
        :class="isVerticalBar ? 'flex-column' : 'flex-row'"
      >
        <div
          v-if="opcao.url_imagem && !isVerticalBar"
          :style="
            isFullScreen ? 'width: 64px; height: 64px' : 'width: 48px; height: 48px;'
          "
          class="triangle-container mr-2"
        >
          <svg
            :width="isFullScreen ? '64' : '48'"
            :height="isFullScreen ? '64' : '48'"
            viewBox="0 0 100 100"
          >
            <polygon points="50,0 100,100 0,100" fill="#eee" />
            <image
              :xlink:href="opcao.url_imagem"
              x="10"
              y="10"
              width="100%"
              height="100%"
            />
          </svg>
          <!-- <img :href="opcao.url_imagem" /> -->
        </div>
        <div
          v-if="isVerticalBar"
          class="d-flex align-center"
          :class="isVerticalBar ? 'flex-column' : 'flex-row'"
        >
          <span
            v-if="!hideOptionTitle"
            class="font-weight-400"
            :class="isFullScreen ? 'text-h6' : 'text-subtitle-2'"
            style="color: whitesmoke"
            >{{ opcao.dsc_titulo }}</span
          >
          <span
            v-if="item.flg_exibir_resultado"
            class="font-weight-bold"
            :class="isFullScreen ? 'text-subtitle-2' : 'text-caption'"
            style="color: whitesmoke"
          >
            {{ opcao.resultado }}%
          </span>
        </div>
        <div class="d-flex flex-column align-start">
          <span
            v-if="!isVerticalBar && !hideOptionTitle"
            class="font-weight-400"
            :class="isFullScreen ? 'text-h6' : 'text-subtitle-2'"
            style="color: whitesmoke"
            >{{ opcao.dsc_titulo }}</span
          >
          <div class="d-flex">
            <div
              v-if="item.flg_exibir_resultado"
              class="rounded"
              :class="
                isFullScreen && isVerticalBar
                  ? 'fullscreen-bar'
                  : !isFullScreen && isVerticalBar
                  ? 'normal-bar'
                  : isFullScreen && !isVerticalBar
                  ? 'fullscreen-horizontal-bar'
                  : 'fullscreen-bar'
              "
              style="border: 1px solid white"
              :style="
                isVerticalBar
                  ? {
                      'background-color': pickRandomColor(opcao),
                      'min-height': '3px',
                      height: `${factor * opcao.resultado}px`,
                    }
                  : {
                      'background-color': pickRandomColor(opcao),
                      'min-width': '3px',
                      'align-self': 'flex-start',
                      height: '32px',
                      width: `${factor * opcao.resultado}px`,
                    }
              "
            ></div>
            <div
              v-if="!isVerticalBar"
              :class="
                isVerticalBar && isFullScreen
                  ? 'align-self-end mx-2 mb-1'
                  : 'align-self-center mx-2'
              "
            >
              <span
                v-if="item.flg_exibir_resultado"
                class="font-weight-bold"
                :class="isFullScreen ? 'text-subtitle-1' : 'text-caption'"
                style="color: whitesmoke"
              >
                {{ opcao.resultado }}%
              </span>
            </div>
          </div>
        </div>
        <div
          v-if="opcao.url_imagem && isVerticalBar"
          :style="
            isFullScreen ? 'width: 64px; height: 64px' : 'width: 48px; height: 48px;'
          "
          class="triangle-container"
        >
          <svg
            :width="isFullScreen ? '64' : '48'"
            :height="isFullScreen ? '64' : '48'"
            viewBox="0 0 100 100"
          >
            <polygon points="50,0 100,100 0,100" fill="#eee" />
            <image
              :xlink:href="opcao.url_imagem"
              x="10"
              y="10"
              width="100%"
              height="100%"
            />
          </svg>
          <!-- <img :href="opcao.url_imagem" /> -->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    posicaoEnquete: String,
    isFullScreen: Boolean,
    hideTitle: Boolean,
    hideOptionTitle: Boolean,
    isVerticalBar: Boolean,
  },
  data() {
    return {
      defaultColors: ["orange", "yellow", "blue", "red", "green"],
      optionsColors: {},
      percentScreenDim: {
        // porcentagem da tela que a div irá ocupar
        maxWidth: 40,
        minWidth: 20,
        minHeight: 30,
        maxHeight: 70,
        fullScreenMaxWidth: 60,
        fullScreenMaxHeight: 80,
        fullScreenMinWidth: 20,
        fullScreenMinHeight: 60,
      },
    };
  },
  created() {
    for (const option of this.item.enquete_opcoes) {
      if (option.dsc_cor_barra) {
        this.optionsColors[option.id] = option.dsc_cor_barra;
      }
    }
  },
  computed: {
    screenDimensions() {
      return {
        width: this.$vuetify.breakpoint.width,
        height: this.$vuetify.breakpoint.height,
      };
    },
    factor() {
      if (!this.isVerticalBar && this.isFullScreen) {
        return 2.5;
      }
      if (this.isFullScreen) {
        return 2.5;
      }
      return 1.5;
    },
    enqueteStyle() {
      let maxWidth, maxHeight, minWidth, minHeight;
      if (this.isFullScreen) {
        minWidth =
          (this.percentScreenDim.fullScreenMinWidth * this.screenDimensions.width) / 100; // 20% of screen width + 20px
        maxWidth =
          (this.percentScreenDim.fullScreenMaxWidth * this.screenDimensions.width) / 100 +
          20; // 60% of screen width + 20px
        minHeight =
          (this.percentScreenDim.fullScreenMinHeight * this.screenDimensions.height) /
          100; // 60% of screen height + 50px
        maxHeight =
          (this.percentScreenDim.fullScreenMaxHeight * this.screenDimensions.height) /
            100 +
          50; // 80% of screen height + 50px
        const fullScreenStyle = `justify-self: center; max-width: ${maxWidth}px !important; max-height: ${maxHeight}px !important;
                                         min-width: ${minWidth}px !important; min-height: ${minHeight}px !important;`;
        return fullScreenStyle;
      }
      const position =
        this.posicaoEnquete === "esquerda" && this.isVerticalBar
          ? "justify-self: flex-start"
          : this.posicaoEnquete === "esquerda" && !this.isVerticalBar
          ? "justify-self: flex-start; margin-left: 50px;"
          : this.posicaoEnquete === "centro"
          ? "justify-self: center"
          : this.posicaoEnquete === "direita" && this.isVerticalBar
          ? "justify-self: flex-end"
          : this.posicaoEnquete === "direita" && !this.isVerticalBar
          ? "justify-self: flex-end; margin-right: 50px;"
          : "";
      const dimensions = "width: 580px; height: 230px";
      const array = position.split(";").concat(dimensions.split(";"));
      return array.filter((item) => item).join(";");
    },
  },
  methods: {
    pickRandomColor(option) {
      //   const shuffledColors = this.shuffleArray(this.defaultColors);
      if (!option.dsc_cor_barra && !this.optionsColors[option.id]) {
        const randomIdx = Math.floor(Math.random() * this.defaultColors.length);
        this.optionsColors[option.id] = this.defaultColors[randomIdx];
      } else if (option.dsc_cor_barra) {
        this.optionsColors[option.id] = option.dsc_cor_barra;
      }
      return this.optionsColors[option.id];
    },
    shuffleArray(array) {
      const copy = array;
      for (let i = copy.length - 1; i > 0; i--) {
        const randomIndex = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[randomIndex]] = [copy[randomIndex], copy[i]];
      }

      return copy;
    },
  },
};
</script>

<style lang="scss" scoped>
.triangle-container {
  position: relative;
  overflow: hidden;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  border-radius: 4px;
}
.triangle-container svg {
  position: absolute;
  top: 0;
  left: 0;
}
.triangle-container img {
  position: relative;
  //   z-index: 1;
  width: 100%; /* Make the image fit the container */
  height: 100%;
  object-fit: cover; /* Maintain aspect ratio */
}
.normal-bar {
  width: 36px;
}
.fullscreen-bar {
  width: 50px;
  //   min-height: 42px !important;
}

.fullscreen-horizontal-bar {
  height: 50px !important;
}

.horizontal-grid {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-row-gap: 15px;
}

.horizontal-grid-fullscreen {
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 20px;
}
</style>
